function t(t){return"string"==typeof t}export{t as default};
//# sourceMappingURL=isHostComponent.js.map
